import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { companyAPI, meetingAPI } from '../services/api';

const BookMeeting = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const [company, setCompany] = useState(null);
  const [slots, setSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      
      console.log('Fetching data for company ID:', companyId);
      
      // Önce company bilgisini al
      const companyResponse = await companyAPI.getById(companyId);
      const company = companyResponse.data.company;
      setCompany(company);
      
      // Slotları al - backend otomatik olarak company'nin event tarihini kullanacak
      const slotsResponse = await companyAPI.getAvailableSlots(companyId);
      
      console.log('Company response:', companyResponse);
      console.log('Slots response:', slotsResponse);
      
      setSlots(slotsResponse.data.slots || []);
      
    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Error loading data: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => {
    if (companyId) {
      fetchData();
    }
  }, [companyId, fetchData]);

  const handleSlotSelect = (slot) => {
    if (slot.is_available) {
      setSelectedSlot(slot);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedSlot) {
      setError('Please select a time slot');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      await meetingAPI.create({
        company_id: companyId,
        meeting_slot_id: selectedSlot.id
      });
      
      setSuccess('Your meeting request has been sent successfully!');
      setTimeout(() => {
        navigate('/my-meetings');
      }, 2000);
    } catch (error) {
      console.error('Error creating meeting:', error);
      setError(error.response?.data?.message || 'Error sending meeting request');
    } finally {
      setSubmitting(false);
    }
  };

  const formatTime = (time) => {
    return time.substring(0, 5);
  };

  const getLogoUrl = (logo) => {
    if (!logo) return null;
    if (logo.startsWith('http')) return logo;
    const baseUrl = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://localhost:8000'
      : 'https://api.uzak.co';
    return `${baseUrl}/logos/${logo}`;
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        fontSize: 'clamp(1rem, 3vw, 1.2rem)',
        color: '#666',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '20px' }}>⏳</div>
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  if (error && !company) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        fontSize: 'clamp(1rem, 3vw, 1.2rem)',
        color: '#dc3545',
        backgroundColor: '#f8f9fa',
        padding: '20px',
        textAlign: 'center'
      }}>
        <div style={{ marginBottom: '20px' }}>⚠️</div>
        <div style={{ marginBottom: '20px' }}>Error: {error}</div>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#EDB404',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: 'clamp(0.9rem, 2.5vw, 1rem)'
          }}
        >
          Back to Home
        </button>
      </div>
    );
  }

  return (
    <div style={{
      maxWidth: '800px',
      margin: '20px auto',
      padding: 'clamp(20px, 5vw, 30px)',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      minHeight: '100vh'
    }}>
      <button
        onClick={() => navigate('/')}
        style={{
          marginBottom: 'clamp(15px, 3vw, 20px)',
          padding: 'clamp(6px, 2vw, 8px) clamp(12px, 3vw, 16px)',
          backgroundColor: '#EDB404',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: 'clamp(0.9rem, 2.5vw, 1rem)'
        }}
      >
        ← Back
      </button>

      {company && (
        <div style={{ marginBottom: 'clamp(20px, 4vw, 30px)' }}>
          <h1 style={{
            fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            fontWeight: 'bold',
            color: '#333',
            marginBottom: 'clamp(10px, 2vw, 15px)',
            textAlign: 'center'
          }}>
            Book Meeting with {company.name}
          </h1>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'clamp(10px, 3vw, 15px)',
            marginBottom: 'clamp(15px, 3vw, 20px)',
            flexWrap: 'wrap'
          }}>
            {company.logo && (
              <img
                src={getLogoUrl(company.logo)}
                alt={`${company.name} logo`}
                style={{
                  width: 'clamp(40px, 10vw, 60px)',
                  height: 'clamp(40px, 10vw, 60px)',
                  borderRadius: '50%',
                  objectFit: 'contain',
                  border: '2px solid #EDB404',
                  backgroundColor: '#f8f9fa',
                  padding: '5px'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            )}
            {/* <div style={{ textAlign: 'center' }}>
              <p style={{
                fontSize: 'clamp(1rem, 3vw, 1.1rem)',
                color: '#666',
                margin: '0'
              }}>
                {company.email}
              </p>
            </div> */}
          </div>

          {/* Company Description */}
          {company.company_description && (
            <div style={{
              marginTop: 'clamp(15px, 3vw, 20px)',
              padding: 'clamp(15px, 3vw, 20px)',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              borderLeft: '4px solid #EDB404'
            }}>
              <h3 style={{
                fontSize: 'clamp(1.1rem, 3vw, 1.3rem)',
                fontWeight: '600',
                color: '#333',
                marginBottom: 'clamp(10px, 2vw, 15px)'
              }}>
                About {company.name}
              </h3>
              <p style={{
                fontSize: 'clamp(0.95rem, 2.5vw, 1rem)',
                color: '#555',
                lineHeight: '1.6',
                margin: '0'
              }}>
                {company.company_description}
              </p>
            </div>
          )}
        </div>
      )}

      {success && (
        <div style={{
          backgroundColor: '#d4edda',
          color: '#155724',
          padding: 'clamp(10px, 3vw, 15px)',
          borderRadius: '8px',
          marginBottom: 'clamp(15px, 3vw, 20px)',
          textAlign: 'center',
          fontSize: 'clamp(0.9rem, 2.5vw, 1rem)'
        }}>
          ✅ {success}
        </div>
      )}

      {error && (
        <div style={{
          backgroundColor: '#f8d7da',
          color: '#721c24',
          padding: 'clamp(10px, 3vw, 15px)',
          borderRadius: '8px',
          marginBottom: 'clamp(15px, 3vw, 20px)',
          textAlign: 'center',
          fontSize: 'clamp(0.9rem, 2.5vw, 1rem)'
        }}>
          ⚠️ Error: {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <h2 style={{
          fontSize: 'clamp(1.2rem, 3vw, 1.4rem)',
          fontWeight: 'bold',
          color: '#333',
          marginBottom: 'clamp(15px, 3vw, 20px)',
          textAlign: 'center'
        }}>
          Select an available time slot:
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(clamp(120px, 20vw, 150px), 1fr))',
          gap: 'clamp(8px, 2vw, 12px)',
          marginBottom: 'clamp(20px, 4vw, 30px)'
        }}>
          {slots.map((slot) => (
            <button
              key={slot.id}
              type="button"
              disabled={!slot.is_available}
              onClick={() => handleSlotSelect(slot)}
              style={{
                padding: 'clamp(8px, 2vw, 10px)',
                border: selectedSlot?.id === slot.id ? '2px solid #EDB404' : '1px solid #ddd',
                borderRadius: '4px',
                backgroundColor: !slot.is_available ? '#EDB404' : selectedSlot?.id === slot.id ? '#e7f3ff' : 'white',
                cursor: slot.is_available ? 'pointer' : 'not-allowed',
                fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
                color: !slot.is_available ? 'white' : 'black',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (slot.is_available) {
                  e.target.style.backgroundColor = selectedSlot?.id === slot.id ? '#e7f3ff' : '#f8f9fa';
                }
              }}
              onMouseLeave={(e) => {
                if (slot.is_available) {
                  e.target.style.backgroundColor = selectedSlot?.id === slot.id ? '#e7f3ff' : 'white';
                }
              }}
            >
              {formatTime(slot.start_time)} - {formatTime(slot.end_time)}
            </button>
          ))}
        </div>

        {slots.length === 0 && (
          <p style={{
            textAlign: 'center',
            color: '#666',
            fontSize: 'clamp(1rem, 3vw, 1.1rem)',
            marginBottom: 'clamp(20px, 4vw, 30px)'
          }}>
            {company?.event 
              ? `No available slots for the event date (${new Date(company.event.event_date + 'T00:00:00').toLocaleDateString()}).`
              : 'No available slots for this company.'}
          </p>
        )}

        <div style={{ textAlign: 'center' }}>
          <button
            type="submit"
            disabled={!selectedSlot || submitting}
            style={{
              backgroundColor: selectedSlot ? '#EDB404' : '#6c757d',
              color: 'white',
              border: 'none',
              padding: 'clamp(12px, 3vw, 15px) clamp(24px, 6vw, 30px)',
              borderRadius: '8px',
              fontSize: 'clamp(1rem, 3vw, 1.1rem)',
              fontWeight: '600',
              cursor: selectedSlot ? 'pointer' : 'not-allowed',
              transition: 'all 0.2s ease',
              minWidth: 'clamp(150px, 30vw, 200px)'
            }}
            onMouseEnter={(e) => {
              if (selectedSlot) {
                e.target.style.backgroundColor = '#d4a017';
                e.target.style.transform = 'translateY(-1px)';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedSlot) {
                e.target.style.backgroundColor = '#EDB404';
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            {submitting ? 'Loading...' : 'Create Meeting'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default BookMeeting;
